import { _ as i } from "./index936.mjs";
import { i as t } from "./index661.mjs";
var y = i, l = t;
function u(r, s, e) {
  var a = s(r);
  return l(r) ? a : y(a, e(r));
}
var o = u;
export {
  o as _
};
